/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ControlsIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "controls", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6.5 5V7.5M6.5 11.5V20M12.5 5V13.5M12.5 17.5V20M18.5 5V7.5M18.5 11.5V20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 6.5, cy: 9.5, r: 2, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 12.5, cy: 15.5, r: 2, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 18.5, cy: 9.5, r: 2, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ControlsIcon);
export default ForwardRef;
//# sourceMappingURL=controlsIcon.js.map